import service from "@/helpers/py-service";

const state = {
  loading: false,
  meta: {},
  list: [],
  //
  comparisonData: {},
  busList: [],
};

const mutations = {
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  UPDATE_LIST(state, payload) {
    const item = state.list.find((item) => item.id === payload.id);
    Object.assign(item, payload);
  },
  DELETE_LIST(state, payload) {
    state.list.splice(state.list.map((o) => o.id).indexOf(payload.id), 1);
  },
  //
  SET_BUS_LIST(state, payload) {
    state.busList = payload;
  },
  SET_COMPARISON_DATA(state, payload) {
    state.comparisonData = payload;
  },
};

const actions = {
  list: (store, params) => {
    store.state.loading = true;
    return service
      .get("fuel-management/fuel-sessions", params)
      .then((data) => {
        store.commit("SET_META", data.body);
        store.commit("SET_LIST", data.body.data);
        return data;
      })
      .finally(() => (store.state.loading = false));
  },
  update: (store, params) => {
    store.state.loading = true;
    return service
      .put(`fuel-management/fuel-sessions`, params)
      .then((data) => {
        store.commit("UPDATE_LIST", data.body);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
  destroy: (store, params) => {
    store.state.loading = true;
    return service
      .destroy(`fuel-management/fuel-sessions`, params)
      .then(() => {
        store.commit("DELETE_LIST", params);
      })
      .finally(() => (store.state.loading = false));
  },
  exportList: (store, params) => {
    store.state.loading = true;
    return service
      .get("fuel-management/download-fuel-sessions", params)
      .then((data) => {
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },

  //
  busNoDropdown: (store, params) => {
    store.state.loading = true;
    return service
      .get("fuel-management/bus-no-dropdown", params)
      .then((data) => {
        store.commit("SET_BUS_LIST", data.body.data);
        return data.body.data;
      })
      .finally(() => (store.state.loading = false));
  },
  createDataLogs: (store, params) => {
    store.state.loading = true;
    return service
      .post("fuel-management/fuel-sessions", params)
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      })
      .finally(() => (store.state.loading = false));
  },
  //
  comparisonLogs: (store, params) => {
    store.state.loading = true;
    return service
      .get("fuel-management/fuel-comparision", params)
      .then((data) => {
        store.commit("SET_COMPARISON_DATA", data.body);
        return data;
      })
      .finally(() => (store.state.loading = false));
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
  getBusList(state) {
    return state.busList;
  },
  getComparisonData(state) {
    return state.comparisonData;
  },
};

const dataLogs = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default dataLogs;
